import { Button } from '@/components/ui/Button'
import { Modal } from '@/components/ui/Modal'
import { formatCurrency } from '@/utils/format-currency'
import type { Deal } from '@/types'

type Props = {
  deal: Deal | null
  onClose: () => void
  onDelete: (dealId: string) => Promise<void>
}

export function RocketSearchDealDetailModal({ deal, onClose, onDelete }: Props) {
  return (
    <Modal
      open={Boolean(deal)}
      onClose={onClose}
      title={deal?.empresaNome || 'Detalhes da negociação'}
      description={deal?.nome || 'Rocket Search'}
      size="lg"
      footer={
        deal ? (
          <div className="flex w-full justify-end gap-2">
            <Button variant="secondary" onClick={onClose}>
              Fechar
            </Button>
            <Button
              variant="destructive"
              onClick={async () => {
                await onDelete(deal.id)
                onClose()
              }}
            >
              Excluir proposta
            </Button>
          </div>
        ) : undefined
      }
    >
      {deal && (
        <div className="grid grid-cols-1 gap-3 text-sm md:grid-cols-2">
          <div className="rounded-lg border border-[var(--glass-border)] bg-[var(--glass-bg)] p-3">
            <p className="text-xs text-[var(--font-color-muted)]">Etapa</p>
            <p className="font-medium text-[var(--font-color-body)]">{deal.etapa}</p>
          </div>
          <div className="rounded-lg border border-[var(--glass-border)] bg-[var(--glass-bg)] p-3">
            <p className="text-xs text-[var(--font-color-muted)]">Valor</p>
            <p className="font-medium text-[var(--font-color-body)]">
              {deal.valor ? formatCurrency(Number(deal.valor)) : '-'}
            </p>
          </div>
          <div className="rounded-lg border border-[var(--glass-border)] bg-[var(--glass-bg)] p-3">
            <p className="text-xs text-[var(--font-color-muted)]">Probabilidade</p>
            <p className="font-medium text-[var(--font-color-body)]">{deal.probabilidade ?? 0}%</p>
          </div>
          <div className="rounded-lg border border-[var(--glass-border)] bg-[var(--glass-bg)] p-3">
            <p className="text-xs text-[var(--font-color-muted)]">Closer</p>
            <p className="font-medium text-[var(--font-color-body)]">{deal.closerNome || '-'}</p>
          </div>
          <div className="rounded-lg border border-[var(--glass-border)] bg-[var(--glass-bg)] p-3 md:col-span-2">
            <p className="text-xs text-[var(--font-color-muted)]">Observações</p>
            <p className="font-medium text-[var(--font-color-body)]">{deal.observacoes || 'Sem observações'}</p>
          </div>
        </div>
      )}
    </Modal>
  )
}
